import { tradingEndpoints } from '../constants/apiEndpoint';
import { GetTradingInfoResponse, TradingFeatureEnum } from '../types/trading';
import { getTradingApiInstance } from './instance/trading';

export const getTradingInfo = async (
  features: TradingFeatureEnum[],
): Promise<GetTradingInfoResponse> =>
  getTradingApiInstance().get(tradingEndpoints.getTradingInfo, {
    params: {
      features: features.join(','),
    },
  });
